import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ScaleIcon, ArrowLeftIcon } from 'lucide-react';
import { TermsAccordion } from '../components/policies/TermsAccordion';
export function Terms() {
  return <>
      <Helmet data-id="element-2437">
        <title data-id="element-2438">Terms & Conditions | Bright Pixxel Studio</title>
        <meta name="description" content="Our terms covering project scope, payments, intellectual property and ownership — clear and fair for every web design project. Read the full terms." data-id="element-2439" />
        <link rel="canonical" href="https://bright-pixxel.com/terms" data-id="element-2440" />
        {/* Open Graph Meta Tags */}
        <meta property="og:locale" content="en_GB" data-id="element-2441" />
        <meta property="og:type" content="website" data-id="element-2442" />
        <meta property="og:title" content="Terms & Conditions | Bright Pixxel Studio" data-id="element-2443" />
        <meta property="og:description" content="Our terms covering project scope, payments, intellectual property and ownership — clear and fair for every web design project. Read the full terms." data-id="element-2444" />
        <meta property="og:url" content="https://bright-pixxel.com/terms" data-id="element-2445" />
        <meta property="og:site_name" content="Bright Pixxel Studio" data-id="element-2446" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-2447" />
        <meta property="og:image:width" content="1200" data-id="element-2448" />
        <meta property="og:image:height" content="630" data-id="element-2449" />
        <meta property="og:image:type" content="image/png" data-id="element-2450" />
        <meta property="og:image:alt" content="Bright Pixxel Studio - Terms & Conditions" data-id="element-2451" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-2452" />
        <meta name="twitter:title" content="Terms & Conditions | Bright Pixxel Studio" data-id="element-2453" />
        <meta name="twitter:description" content="Our terms covering project scope, payments, intellectual property and ownership — clear and fair for every web design project. Read the full terms." data-id="element-2454" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-2455" />
        <meta name="twitter:image:alt" content="Bright Pixxel Studio - Terms & Conditions" data-id="element-2456" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-2457">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2458">
          <div className="max-w-4xl mx-auto" data-id="element-2459">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-2460">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-2461" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-2462">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-2463">
                <ScaleIcon size={24} className="text-[#0C1B26]" data-id="element-2464" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-2465">
                Terms & Conditions
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-2466">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-2467">
              These Terms & Conditions ("Terms") govern the relationship between
              Bright Pixxel Studio ("we", "us", "our") and clients ("you",
              "your") who engage our services. By using our services, you agree
              to be bound by these Terms.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-2468">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2469">
          <div className="max-w-4xl mx-auto" data-id="element-2470">
            <TermsAccordion data-id="element-2471" />
          </div>
        </div>
      </section>
    </>;
}